module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"update_review":"Update Review"}}')
  delete Component.options._Ctor
}
